import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 14l-3 -3l8 -8h6l-11 11","key":"svg-0"}],["path",{"d":"M14 21l-5 -5l5 -5h5l-5 5l5 5l-5 0","key":"svg-1"}]]

/**
 * IconBrandFlutter
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtZmx1dHRlciIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNNyAxNGwtMyAtM2w4IC04aDZsLTExIDExIiAvPgogIDxwYXRoIGQ9Ik0xNCAyMWwtNSAtNWw1IC01aDVsLTUgNWw1IDVsLTUgMCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/brand-flutter
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandFlutter = createReactComponent('outline', 'brand-flutter', 'BrandFlutter', __iconNode);

export default IconBrandFlutter;